export default {
    'language-switcher': {
        'switch-to': '{languageCode}',
        languageCode: {
            en: 'EN',
            es: 'SP',
            fr: 'FR'
        }
    }
};
